var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _copyLabel, copyLabel_get, _handleCopy, handleCopy_fn;
import { HznTooltip } from "@horizon/tooltip";
import { HznIconCopy } from "@horizon/icons/individual";
import { LitElement, html } from "@horizon/base";
import { ScopedElementsMixin } from "@open-wc/scoped-elements/lit-element.js";
import { property, query, state } from "@horizon/base/decorators";
import { classMap } from "@horizon/base/directives.js";
import CopyButtonStyles from "./copy-button.css.js";
class HznCopyButton extends ScopedElementsMixin(LitElement) {
  constructor() {
    super(...arguments);
    __privateAdd(this, _copyLabel);
    /**
     * @private
     */
    __privateAdd(this, _handleCopy);
    this.isCopying = false;
    this.status = "rest";
    this.copyLabel = "";
    this.disabled = false;
    this.hoist = false;
    this.value = "";
    this.from = "";
    this.tone = "neutral";
  }
  /**
   * @private
   */
  static get scopedElements() {
    return {
      "hzn-tooltip": HznTooltip,
      "hzn-icon-copy": HznIconCopy
    };
  }
  /**
   * @private
   */
  showStatus(status) {
    const successLabel = "Copied";
    const errorLabel = "Error";
    this.tooltip.content = status === "success" ? successLabel : errorLabel;
    this.status = status;
    setTimeout(() => {
      this.status = "rest";
      this.tooltip.content = __privateGet(this, _copyLabel, copyLabel_get);
      this.isCopying = false;
    }, 1350);
  }
  render() {
    return html`
      <hzn-tooltip
        ?inert=${this.disabled}
        ?hoist=${this.hoist}
        content=${__privateGet(this, _copyLabel, copyLabel_get)}
        icon="none"
        >
        <button
          @click=${__privateMethod(this, _handleCopy, handleCopy_fn)}
          aria-label=${__privateGet(this, _copyLabel, copyLabel_get)}
          ?disabled=${this.disabled}
          class=${classMap({
      "copy-button": true,
      "is-disabled": Boolean(this.disabled),
      "is-tone-neutral": this.tone !== "interactive",
      "is-tone-interactive": this.tone === "interactive"
    })}
        >
          <hzn-icon-copy></hzn-icon-copy>
        </button>
      </hzn-tooltip>
    `;
  }
}
_copyLabel = new WeakSet();
copyLabel_get = function() {
  return this.copyLabel || "Copy";
};
_handleCopy = new WeakSet();
handleCopy_fn = async function() {
  if (this.disabled || this.isCopying) {
    return;
  }
  this.isCopying = true;
  let valueToCopy = this.value;
  if (this.from) {
    const root = this.getRootNode();
    const isProperty = this.from.includes(".");
    const isAttribute = this.from.includes("[") && this.from.includes("]");
    let id = this.from;
    let field = "";
    if (isProperty) {
      [id, field] = this.from.trim().split(".");
    } else if (isAttribute) {
      [id, field] = this.from.trim().replace(/\]$/, "").split("[");
    }
    const target = "getElementById" in root ? root.getElementById(id) : null;
    if (target) {
      if (isAttribute) {
        valueToCopy = target.getAttribute(field) || "";
      } else if (isProperty) {
        valueToCopy = target[field] || "";
      } else {
        valueToCopy = target.textContent || "";
      }
    } else {
      this.showStatus("error");
    }
  }
  if (!valueToCopy) {
    this.showStatus("error");
  } else {
    try {
      await navigator.clipboard.writeText(valueToCopy);
      this.showStatus("success");
    } catch (error) {
      this.showStatus("error");
    }
  }
};
HznCopyButton.styles = [CopyButtonStyles];
__decorateClass([
  state()
], HznCopyButton.prototype, "isCopying", 2);
__decorateClass([
  state()
], HznCopyButton.prototype, "status", 2);
__decorateClass([
  query(".copy-button")
], HznCopyButton.prototype, "innerButton", 2);
__decorateClass([
  query("hzn-tooltip")
], HznCopyButton.prototype, "tooltip", 2);
__decorateClass([
  property({ type: String, attribute: "copy-label", reflect: false })
], HznCopyButton.prototype, "copyLabel", 2);
__decorateClass([
  property({ type: Boolean })
], HznCopyButton.prototype, "disabled", 2);
__decorateClass([
  property({ type: Boolean })
], HznCopyButton.prototype, "hoist", 2);
__decorateClass([
  property({ type: String })
], HznCopyButton.prototype, "value", 2);
__decorateClass([
  property()
], HznCopyButton.prototype, "from", 2);
__decorateClass([
  property({ type: String })
], HznCopyButton.prototype, "tone", 2);
export {
  HznCopyButton
};
//# sourceMappingURL=copy-button.js.map
